import React from "react";
import styled from "styled-components";

export const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 15px;
  padding: 20px;
  overflow: auto;
  .table tbody tr td,
  .table thead tr th {
    padding: 26px !important;
    font-family: "Inter", sans-serif;
    border-bottom: 0px !important;
  }

  .table th {
    background-color: #f8f9fa !important;
    padding: 26px !important;
    color: #4e5d78 !important;
    font-family: "Inter", sans-serif;
  }
  td {
    padding: 20px;
    margin-top: 12px;
    font-size: 14px;
    font-family: "Inter", sans-serif;
    border-bottom: 0px !important;
  }

  tbody tr:hover {
    background-color: ${(props) =>
      props["data-isvtex"] ? "#baf76a26" : "#fff6f4"};
  }
  input[type="checkbox"] {
    width: 16px;
    height: 15px;
    accent-color: #ff5837;
  }

  .status_div {
    background-color: #fdf4e0;
    color: #ffbd37;
    width: 200px;
    height: 30px;
    text-align: center;
    border-radius: 10px;
    padding: 5px;
  }
  .payment_div {
    background-color: #e5f6ef;
    color: #38cb7c;
    width: 100px;
    height: 30px;
    text-align: center;
    border-radius: 10px;
    padding: 5px;
  }
`;
